export default {
  title: "Membres de l'organisation",
  subtitle: 'Voir tous les membres de cette organisation',
  invite: 'Inviter des membres',
  pending: {
    title: 'Invitations',
    subtitle: "Personnes invitées à rejoindre cette organisation qui n'ont pas encore accepté",
    sent: 'Envoyée',
    alreadyGone: 'Cette invitation avait déjà été acceptée, retirée, ou avait expiré.',
    cancelTitle: 'Annuler cette invitation',
    cancelDescription: 'Le lien envoyé à {email} cesse immédiatement de fonctionner.',
    cancelConfirm: "Annuler l'invitation",
    keep: 'La conserver',
  },
  table: {
    title: 'Membres ({count})',
    search: 'Rechercher des membres...',
    name: 'Nom',
    role: 'Rôle',
    access: 'Accès',
    status: 'Statut',
    joinedAt: 'Rejoint le',
    workspaces: 'Espaces',
    noWorkspace: 'Aucun espace',
    moreWorkspaces: '+{count}',
    moreWorkspacesLink: '+ {count} autres espaces',
    pool: 'Fonds commun',
    implicitSeat: 'Accès implicite : propriétaire ou administrateur',
    autoAddedSeat: 'Ajouté automatiquement',
    workspacesFailed: "Les espaces des membres n'ont pas pu être chargés.",
  },
  status: {
    active: 'Actif',
    pending: 'En attente',
    inactive: 'Inactif',
  },
  access: {
    allSpaces: 'Tous les espaces',
    space: '{count} espace',
    spaces: '{count} espaces',
    publicOnly: 'Espaces publics',
  },
  empty: {
    title: 'Aucun membre trouvé',
    description: "Cette organisation n'a pas encore de membres.",
    noMatch: 'Aucun membre ne correspond à cette recherche.',
  },
  delete: {
    title: 'Retirer le membre',
    warning: "Ce membre perdra l'accès à l'organisation. Cette action est irréversible.",
    confirm: 'Retirer le membre',
    success: 'Membre retiré avec succès',
  },
  editRole: {
    title: 'Modifier le rôle du membre',
    selectLabel: 'Rôle',
    success: 'Rôle mis à jour avec succès',
    adminDescription: 'Accès complet à toutes les fonctionnalités et paramètres',
    memberDescription: 'Peut consulter et modifier le contenu',
    viewerDescription: 'Peut uniquement consulter le contenu',
    cannotEditSelf: 'Vous ne pouvez pas modifier votre propre rôle',
  },
  actions: 'Actions',
  menu: {
    addToWorkspace: 'Ajouter à un espace',
    viewDetail: 'Voir les détails',
  },
  cannotRemoveSelf: 'Vous ne pouvez pas vous retirer vous-même',
  errors: {
    updateFailed: 'Erreur lors de la mise à jour du rôle',
    removeFailed: 'Erreur lors du retrait du membre',
    forbidden: 'Vous ne pouvez pas agir sur ce membre, ou attribuer ce rôle.',
    lastAdministrator: "Ce changement laisserait l'organisation sans personne pour l'administrer.",
    gone: "Ce membre ne fait plus partie de l'organisation.",
    seatGone: 'Cette personne ne fait plus partie de cet espace.',
  },
  tabs: {
    members: 'Membres',
    invitations: 'Invitations',
  },
  invitations: {
    emailTitle: 'Invitations par email ({count})',
    linksTitle: "Liens d'invitation ({count})",
    emailSectionTitle: 'Invitations par e-mail',
    emailSectionDesc: "Personnes invitées personnellement qui n'ont pas encore rejoint.",
    linksSectionTitle: "Liens d'invitation",
    linksSectionDesc: 'Liens partageables — une URL pour rejoindre, sans saisir d’e-mails.',
    linksCount: '{count} lien',
    linksCountPlural: '{count} liens',
    pendingCount: '{count} en attente',
    expiredCount: '{count} expirée',
    expiredCountPlural: '{count} expirées',
    expiredBanner: 'Certaines invitations ont expiré — utilisez « Renouveler & renvoyer » pour générer un nouveau lien valide.',
    sentTimes: 'Envoyée {count}×',
    table: {
      email: 'Email',
      name: 'Nom',
      unnamed: '(sans nom)',
      role: 'Rôle',
      workspaces: 'Espaces',
      invitedBy: 'Invité par',
      expires: 'Expiration',
      sendCount: 'Envoyé',
      code: 'Lien',
      status: 'Statut',
      uses: 'Utilisations',
      createdBy: 'Créé par',
    },
    actions: {
      resend: 'Relancer',
      renewResend: 'Renouveler & renvoyer',
      editAccess: "Modifier l'accès",
      cancel: "Annuler l'invitation",
      copyLink: 'Copier le lien',
      activate: 'Activer le lien',
      deactivate: 'Désactiver le lien',
      deleteLink: 'Supprimer le lien',
    },
    editAccess: {
      title: "Modifier l'accès de l'invitation",
      pending: 'Invitation en attente',
      success: "Accès de l'invitation mis à jour",
      failed: "Échec de la mise à jour de l'accès",
    },
    detail: {
      title: "Détails du lien d'invitation",
      url: 'URL à partager',
      orgRole: "Rôle dans l'organisation",
      workspaceRoles: 'Affectations workspaces',
      noWorkspaces: 'Aucun workspace associé',
      uses: 'Utilisations',
      expires: 'Expiration',
      createdBy: 'Créé par {name}',
    },
    expiry: {
      expired: 'Expiré',
      today: "Expire aujourd'hui",
      tomorrow: 'Expire demain',
      expiresIn: 'Expire dans {days} jours',
      noExpiry: 'Sans expiration',
    },
    status: {
      exhausted: 'Limite atteinte',
    },
    empty: {
      noPending: 'Aucune invitation en attente',
      noPendingDescription: 'Toutes les invitations ont été acceptées ou annulées.',
      noLinks: "Aucun lien d'invitation",
      noLinksDescription: "Créez un lien d'invitation depuis la modale d'invitation.",
    },
    resendSuccess: 'Invitation renvoyée à {email}',
    resendTooSoon: "Trop d'invitations envoyées pour le moment — réessayez plus tard.",
    resendGone: "Cette invitation n'est plus en attente : elle a été acceptée, annulée, ou elle a expiré.",
    resendRefused:
      'Cette invitation ne peut plus être relancée telle quelle — son rôle a peut-être été supprimé. Annulez-la et invitez de nouveau cette personne.',
    resendAlreadyMember: "{email} a déjà rejoint l'organisation.",
    renewSuccess: 'Invitation renouvelée — un nouveau lien a été envoyé',
    resendFailed: "Erreur lors du renvoi de l'invitation",
    cancelSuccess: 'Invitation annulée',
    cancelFailed: "Erreur lors de l'annulation de l'invitation",
    linkCopied: 'Lien copié dans le presse-papier',
    linkActivated: 'Lien activé',
    linkDeactivated: 'Lien désactivé',
    linkDeleted: 'Lien supprimé',
    linkDeleteFailed: 'Erreur lors de la suppression du lien',
    unlimited: 'Illimité',
  },
  filters: {
    role: 'Rôle',
    status: 'Statut',
    allRoles: 'Tous les rôles',
    allStatuses: 'Tous les statuts',
    clear: 'Effacer les filtres',
  },
  stats: {
    total: 'Total des membres',
    active: 'Actifs',
    pending: 'En attente',
    totalNote: "Membres de l'organisation",
    activeNote: 'Ont accepté et se sont connectés',
    pendingNote: 'Invitations pas encore acceptées',
  },
  detail: {
    viewDetail: 'Voir les détails du membre',
    back: 'Retour aux membres',
    memberSince: 'Membre depuis',
    invitedBy: 'Invité par',
    owner: 'Propriétaire',
    you: 'Vous',
    notFound: "Ce membre ne fait plus partie de l'organisation.",
    roleTitle: "Rôle dans l'organisation",
    roleHint: "Le changement s'applique immédiatement, dès sa prochaine action.",
    access: {
      title: 'Accès aux espaces',
      desc: "Ce à quoi {name} a accès dans l'organisation.",
      implicitAll: "A accès à tous les espaces de l'organisation.",
      implicitPublic: 'Voit tous les espaces publics en Lecteur, en plus des espaces ci-dessous.',
      fullAccessNote: "Ce membre a un accès complet à tous les espaces via son rôle. Les affectations par espace ne s'appliquent pas.",
      assignedCount: 'Espaces attribués · {count}',
    },
    workspaces: {
      title: 'Espaces ({count})',
      name: 'Espace',
      role: 'Rôle',
      joinedOn: 'Depuis le {date}',
      fullAccess: 'Accès complet',
      public: 'Public',
      private: 'Privé',
      noWorkspaces: "Ce membre n'est dans aucun espace.",
      removeConfirm: "Retirer de l'espace ?",
      removeWarning: "Ce membre perdra l'accès à cet espace.",
      removeSuccess: "Membre retiré de l'espace",
      addToWorkspace: 'Ajouter à un espace',
      allJoined: 'Ce membre fait déjà partie de tous les espaces.',
      searchPlaceholder: 'Rechercher un espace',
      noMatch: 'Aucun espace ne correspond à cette recherche.',
      addConfirm: 'Ajouter',
      addConfirmCount: 'Ajouter | Ajouter à {count} espace | Ajouter à {count} espaces',
      addRefused: 'Non ajouté à {names}.',
      listLabel: 'Espaces',
      addSuccess: "Membre ajouté à l'espace",
      addSuccessCount: 'Membre ajouté à {count} espace | Membre ajouté à {count} espaces',
      addFailed: "Erreur lors de l'ajout à l'espace",
    },
  },
}
